import { Component, OnChanges, SimpleChanges, Input, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Location } from '@angular/common';
import { MyTurn } from '../../player-clock/player-clock.component';
@Component({
    selector: 'linear-progress',
    templateUrl: './linear-progress.component.html',
    styleUrls: ['./linear-progress.component.scss'],
    standalone: false
})

/**
 * A UI component for showing a circular progress bar.
 * source: https://coryrylan.com/blog/angular-progress-component-with-svg
 */
export class LinearProgressComponent implements OnChanges {
    @Input() currentProgress: MyTurn | null = { clockProgress: 0, isDealyStarted: false};
    @Input() background = '#ccc';
    @Input() color = '#1d1d1d';
    @Input() stroke = 4;
    @Input() rectDimention = 'M 0,2 h100 ';

    protected pathColor = this.color;
    protected circumference: number = 100;
    protected dashoffset: number;
    protected counter = 0;

    constructor(private platform: Platform, private location: Location, private element: ElementRef) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.currentProgress && changes.currentProgress.currentValue) {
            if (changes.currentProgress.currentValue !== changes.currentProgress.previousValue) {
                this.progress(changes.currentProgress.currentValue);
            }
        } else {
            this.progress({ clockProgress: 0, isDealyStarted: false});
        }
    }

    private progress(currentProgress: MyTurn) {
        const progress = Math.min(currentProgress.clockProgress, 100) / 100;
        this.dashoffset = this.circumference * progress;
        if (currentProgress.isDealyStarted == true) {
            if (this.counter % 2 == 0) {
                this.pathColor = 'red';
            } else {
                this.pathColor = '#ffeb3b';
            }
            this.counter++;
        } else {
            this.pathColor = this.color;
        }
    }

    style() {
        if ( this.currentProgress === null || !this.currentProgress.isDealyStarted ) {
            return this.circumference - this.dashoffset;
        } else {
            return '0';
        }
    }

    getUrl(effect: string) {
        return `url(${this.location.path()}#${effect})`;
    }
}
